


















































import Component from "vue-class-component";
import { Prop } from "vue-property-decorator";
import Base from "@/components/core/Base.vue";
import { productsService } from "@/services/products.service";
import { SearchProduct } from "@/model/SearchProduct";
import { Product } from "@/model/Product";
import { PRODUCT_TYPES_IMAGES, PRODUCT_TYPES_NAMES } from "./menus.constants";
import AddProductToDb from "./AddProductToDb.vue";

const SEARCH_TIMEOUT = 300;

@Component({
  components: {
    AddProductToDb
  }
})
export default class ProductSearchField extends Base {
  @Prop({ required: false, default: false })
  filled!: boolean;

  @Prop({ required: false, default: false })
  autofocus!: boolean;

  @Prop({ required: false })
  rules!: unknown[];

  @Prop({ required: false })
  label!: string;

  @Prop({ required: true })
  mProduct!: Partial<Product>;

  search = "";

  items: SearchProduct[] = [];

  searchTimeout = 0;

  mLoading = false;

  async request(value: string) {
    if (!value) return;
    this.mLoading = true;
    productsService
      .search(value)
      .then(searchProducts => {
        this.items = searchProducts;
      })
      .finally(() => {
        this.mLoading = false;
      });
  }

  keyUp(event: KeyboardEvent) {
    if (event.target instanceof HTMLInputElement) {
      const { value } = event.target;
      clearTimeout(this.searchTimeout);
      this.searchTimeout = window.setTimeout(() => {
        this.request(value);
      }, SEARCH_TIMEOUT);
    }
  }

  get value(): string {
    return this.mProduct.name || "";
  }

  onFocus() {
    this.items = [];
  }

  beforeDestroy() {
    clearTimeout(this.searchTimeout);
  }

  typeName(typeCode: string) {
    return PRODUCT_TYPES_NAMES[typeCode] || "inconnu";
  }

  typeImg(typeCode: string) {
    return PRODUCT_TYPES_IMAGES[typeCode];
  }

  hasPrice(sProduct: SearchProduct) {
    return !!sProduct.price;
  }

  hasOrigins(sProduct: SearchProduct) {
    return sProduct.origins.length > 0;
  }

  hasAllergens(sProduct: SearchProduct) {
    return sProduct.allergens.length > 0;
  }

  hasNutriscore(sProduct: SearchProduct) {
    return sProduct.nutriscore;
  }
}
